import { MARKETING_URL } from '../lib/config'
import './footer.css'

// Global footer: a link back to the marketing site plus legal links. The legal
// pages live on the marketing site, so they hang off MARKETING_URL too.
export function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <a className="site-footer__brand" href={MARKETING_URL} rel="noopener">
          TryVouchr
        </a>
        <nav className="site-footer__links" aria-label="Footer">
          <a href={`${MARKETING_URL}/privacy`} rel="noopener">
            Privacy Policy
          </a>
          <a href={`${MARKETING_URL}/terms`} rel="noopener">
            Terms
          </a>
        </nav>
        <span className="site-footer__copy">© {year} Vouchr</span>
      </div>
    </footer>
  )
}
